import { createStyles, makeStyles, Theme } from "@material-ui/core";

export const inputWidth = "450px";

export default makeStyles((theme: Theme) =>
	createStyles({
		pageName: {
			fontWeight: 600,
			fontSize: "24px",
		},
		organizationContainer: {
			marginBottom: 80,
			paddingBottom: 10,
			width: "100%",
		},
		displayFlex: {
			display: "flex",
		},
		myRolesContainer: {
			width: "100%",
			boxShadow: "none",
		},
		newTabLink: {
			paddingLeft: theme.spacing(1),
			display: "flex",
		},
		newTabLinkIcon: {
			paddingBottom: theme.spacing(0.625),
			paddingLeft: theme.spacing(1),
			fontSize: "25px",
			cursor: "pointer",
		},
		cursorPointer: {
			cursor: "pointer",
		},
		tableColumnTextColor: {
			color: "#969392",
		},
		organizationUsersContainer: {
			maxWidth: "400px",
			width: "372px",
			maxHeight: "816px",
			overflowY: "auto",
			boxShadow: "0 0 0.5rem 0 rgb(0 0 0 / 8%)",
			paddingTop: "12px",
			paddingBottom: "24px",
			backgroundColor: "#fff",
			borderRadius: "4px",
		},
		divider: {
			align: "left",
		},
		agreementSpecificRolesContent: {
			marginTop: 16,
			maxHeight: 456,
			overflowY: "auto",
			overflowX: "hidden",
			margin: "0 -3px",
			minHeight: 456,
			"& tr": {
				"&:nth-child(even)": {
					backgroundColor: "#f5f8f9",
				},
			},
		},
		domainTable: {
			width: "100%",
			borderCollapse: "collapse",
			overflowY: "auto",
			"& td": {
				paddingTop: 10,
				paddingBottom: 10,
			},
			"& th": {
				paddingBottom: 10,
			},
		},
		scrollableTableContainer: {
			maxHeight: 500,
			overflowY: "auto",
		},
		domainTableContainer: {
			"& tr:nth-child(odd)": {
				backgroundColor: "#f5f8f9",
			},
		},
		filterSettingContainer: {
			position: "fixed",
			right: 0,
			left: 0,
			top: "76px",
			zIndex: 12,
			boxShadow: "0 0 0.5rem 0 rgb(0 0 0 / 8%)",
			backgroundColor: "#fff",
			padding: "14px 60px",
			borderRadius: "4px",
		},
		organizationActionSettingsContainer: {
			maxWidth: "100%",
			backgroundColor: "#fff",
			padding: "32px",
			borderRadius: "4px",
		},
		menuItemContent: {
			paddingTop: theme.spacing(0.25),
			maxWidth: "300px",
			whiteSpace: "normal",
		},
		operativeDataAccessContainer: {
			maxHeight: "244px",
			overflow: "auto",
		},
		secElement: {
			paddingTop: 15,
			height: "70px",
		},
		operativeDataElement: {
			display: "flex",
			maxWidth: "25%",
			justifyContent: "space-between",
			alignItems: "flex-start",
		},
		rightsLabel: {
			fontWeight: "bold",
			maxHeight: "50px",
		},
		optionDescription: {
			color: "#A7B1B9",
			fontSize: "13px",
		},
		defaultAgreementRolesContainer: {
			marginTop: 16,
			maxHeight: "456px",
			overflowY: "auto",
			"& th": {
				width: "10%",
			},
		},
		agreementsTable: {
			width: "100%",
			borderCollapse: "collapse",
			overflowX: "auto",
			"& th": {
				position: "sticky",
				top: "0",
				zIndex: 7,
				fontSize: "14px",
				backgroundColor: "white",
				fontWeight: 600,
				textAlign: "left",
				paddingBottom: theme.spacing(1),
				paddingLeft: "18px",
				whiteSpace: "nowrap",
			},
			"& td": {
				border: "none",
				paddingLeft: "18px",
				"& div": {
					height: "40px",
					whiteSpace: "nowrap",
					overflow: "hidden",
					"&.MuiSelect-select": {
						height: "fit-content",
					},
				},
			},
		},
		infoIcon: {
			marginLeft: "8px",
			verticalAlign: "middle",
			width: "20px",
			color: "#367bf5",
			cursor: "pointer",
		},
		generalConfigurationTable: {
			borderCollapse: "collapse",
			overflowX: "auto",
			"& thead": {
				zIndex: 2,
			},
			"& tr": {
				"&:nth-child(even)": {
					backgroundColor: "#f5f8f9",
				},
			},
			"& th": {
				"&:nth-child(1)": {
					textAlign: "left",
				},
				"&:last-child": {
					width: "30%",
				},
				position: "sticky",
				top: 0,
				zIndex: 7,
				backgroundColor: "white",
				textAlign: "center",
				fontSize: "14px",
				fontWeight: 600,
				paddingTop: theme.spacing(2),
				paddingBottom: theme.spacing(1),
				paddingLeft: "18px",
				whiteSpace: "nowrap",
			},
			"& td": {
				"&:nth-child(1)": {
					textAlign: "left",
				},
				padding: "1px 0 1px 18px",
				border: "none",
				textAlign: "center",
			},
		},
		applyToAllButton: {
			fontWeight: 400,
			padding: "2px 12px",
			textTransform: "inherit",
			borderRadius: 10,
			marginLeft: -12,
			"&:hover": {
				cursor: "pointer",
				backgroundColor: "#367bf533",
				boxShadow: "none",
			},
		},
		myRoleGeneralConfiguration: {
			fontWeight: 600,
			textAlign: "center",
			marginRight: "50px",
		},
		userMailColumn: {
			overflow: "hidden",
			textOverflow: "ellipsis",
			maxWidth: "250px",
			textAlign: "left",
		},
		deleteDomainBtn: {
			color: theme.palette.error.main,
			borderColor: theme.palette.error.main,
			"&.Mui-disabled": {
				borderColor: "#f6a9a6",
				color: "#f6a9a6",
			},
		},
		weight600: {
			fontWeight: 600,
		},
		textAlignLeft: {
			textAlign: "left",
		},
	})
);
